<app-modal-refactor
  [imageClose]="'../../../assets/images/Close_modal.svg'"
  [showImageClose]=true
  >
  <div body class="container-air-lines">
    <div>
      <img [src]="imgOperatingCarrier" alt="">
    </div>
    <div class="txt-main-air-lines">

    <span [innerText]="'airLines.title' | translate:{value:txtOperatingCarrier}"></span>
    </div>
    <div class="txt-second-air-lines">
      <span class="text-white" [innerText]="'airLines.desc' | translate:{valueTxt:txtOperatingCarrier,valueUrl:urlOperatingCarrier}"></span>
    </div>
  </div>
</app-modal-refactor>
